module.exports = __webpack_public_path__ + "static/media/loan repayment.4d08f21d.png";